import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// The app is on screen: let the splash of the native apps fade out (public/splash.js).
requestAnimationFrame(() => window.__rtSplashHide?.());
